import { useSelector } from 'react-redux';
import { RootState } from '../App';
import { FeedOrderState } from '../state/feedOrderSlice';
import { FullPost, Post, isDefined } from 'model';

/**
 * Hook that sorts the feed by the feed order stored in FeedOrderState
 * @param { FullPost[] } feed The feed items
 * @returns { FullPost[] } The feed items in the order specified by the feed order
 */
export const useFeedOrder = (feed: FullPost[]): FullPost[] => {
	const state: FeedOrderState = useSelector<RootState, FeedOrderState>(state => state.feedOrder);
	const order = state.feedOrder;
	if (!order || order.length === 0) {
		return feed;
	}
	// reduce feed to a Map of id to post
	const feedMap = feed.reduce((map, post) => {
		map.set(post._id, post);
		return map;
	}, new Map<string, Post>());

	// iterate over the order and return the posts in order
	const orderedFeed = order.map(id => feedMap.get(id)).filter(isDefined);
	return (orderedFeed || []) as FullPost[];
};
